import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleScrollTo = (e, hash) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById(hash.substring(1));
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      const el = document.getElementById(hash.substring(1));
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="border-t border-slate-200 bg-slate-50 pt-20 pb-10">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <div className="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center">
                <SafeIcon name="Hexagon" className="text-white text-lg" />
              </div>
              <span className="text-xl font-bold text-slate-900">Digital Ways</span>
            </Link>
            <p className="text-slate-500 text-sm leading-relaxed mb-6">
              Building digital products that solve real problems. From infrastructure to end-user applications.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center text-slate-400 hover:text-indigo-600 hover:border-indigo-200 transition-all shadow-sm"><SafeIcon name="Twitter" /></a>
              <a href="#" className="w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center text-slate-400 hover:text-indigo-600 hover:border-indigo-200 transition-all shadow-sm"><SafeIcon name="Github" /></a>
              <a href="#" className="w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center text-slate-400 hover:text-indigo-600 hover:border-indigo-200 transition-all shadow-sm"><SafeIcon name="Linkedin" /></a>
            </div>
          </div>

          <div>
            <h4 className="text-slate-900 font-bold mb-6 tracking-tight">Products</h4>
            <ul className="space-y-4 text-sm font-medium text-slate-500">
              <li><a href="https://sharemyimage.com" target="_blank" rel="noreferrer" className="hover:text-indigo-600 transition-colors">ShareMyImage</a></li>
              <li><a href="https://abiggb.com" target="_blank" rel="noreferrer" className="hover:text-indigo-600 transition-colors">aBigGB</a></li>
              <li><a href="https://shipassure.in" target="_blank" rel="noreferrer" className="hover:text-indigo-600 transition-colors">ShipAssure</a></li>
              <li><a href="https://royalstar.co.in" target="_blank" rel="noreferrer" className="hover:text-indigo-600 transition-colors">Royal Star</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-slate-900 font-bold mb-6 tracking-tight">Company</h4>
            <ul className="space-y-4 text-sm font-medium text-slate-500">
              <li><a href="#about" onClick={(e) => handleScrollTo(e, '#about')} className="hover:text-indigo-600 transition-colors">About Us</a></li>
              <li><a href="#" className="hover:text-indigo-600 transition-colors">Careers</a></li>
              <li><a href="#" className="hover:text-indigo-600 transition-colors">Blog</a></li>
              <li><a href="#contact" onClick={(e) => handleScrollTo(e, '#contact')} className="hover:text-indigo-600 transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-slate-900 font-bold mb-6 tracking-tight">Legal</h4>
            <ul className="space-y-4 text-sm font-medium text-slate-500">
              <li><Link to="/privacy-policy" className="hover:text-indigo-600 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="hover:text-indigo-600 transition-colors">Terms of Service</Link></li>
              <li><Link to="/cookie-policy" className="hover:text-indigo-600 transition-colors">Cookie Policy</Link></li>
            </ul>
          </div>

        </div>

        <div className="pt-8 border-t border-slate-200 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm font-medium">
            © {new Date().getFullYear()} Digital Ways. All rights reserved.
          </p>
          <div className="flex items-center gap-2 text-sm font-medium text-slate-500">
            <span>Designed with</span>
            <SafeIcon name="Heart" className="text-rose-500 text-sm" />
            <span>for the future</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;